import React from "react"
import { Tooltip as PrimeTooltip } from "primereact/tooltip"
/**
 * @type {React.ForwardRefRenderFunction<
 *   import('primereact/tooltip').Tooltip,
 *   import('primereact/tooltip').TooltipProps
 * >}
 */
const Tooltip = React.forwardRef((props, ref) => {
  return <PrimeTooltip {...props} ref={ref} />
})

export default Tooltip
